import DIApi from '@/apis/di/_diApi';

class FilterHistoryAPI extends DIApi {
  controllerName = 'FilterHistorys';
}

export default new FilterHistoryAPI();
